import NavPayloadAction from '@carvana/merch-native/NavPayloadAction';
import { SELL_MY_CAR_URL } from '~/constants/srp';
import { useConfiguration } from '~/context/common/StaticContext';
import ConditionalTile from './ConditionalTile';

type OwnProps = {
  position: number;
};

export default function TradeinTile({ position }: OwnProps) {
  const { shouldUseTitleCasing } = useConfiguration();

  return (
    <ConditionalTile
      anchorProps={{
        id: 'TradeinTile',
        'data-analytics-id': 'Conditional Tile',
        'data-native-payload': JSON.stringify({
          action: NavPayloadAction.ViewTrades
        }),
        'data-analytics-attributes': JSON.stringify({
          action: 'clicked',
          tile: 'TradeinTile',
          position
        }),
        href: SELL_MY_CAR_URL
      }}
      ctaCopy={shouldUseTitleCasing ? 'Get Your Offer' : 'Get your offer'}
      description="Get a real offer in less than 2 minutes. Sell, trade or track your value."
      imageProps={{
        src: `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/heliosConditionalTiles/trade-illustration.png`,
        alt: 'TradeIn'
      }}
      position={position}
      tileName="TradeinTile"
      title="Trade in your car"
    />
  );
}
